import {ConversationThread} from './messages-workspace.model';
import {convertTimestamp} from '../../utility/time';

/** Existing last-message/last-read semantics: one unread count per conversation. */
export function isConversationUnread(thread: ConversationThread, actor: string): boolean {
  if (!actor || !thread.participantIds?.includes(actor) || thread.lastMessage?.senderId === actor) {
return false;
}
  const lastMessage = convertTimestamp(thread.lastMessage?.createdAt ?? thread.updatedAt)?.getTime() ?? 0;
  const lastRead = convertTimestamp(thread.lastReadAtBy?.[actor])?.getTime() ?? 0;
  return lastMessage > lastRead;
}
